import { Select } from 'antd';
import { useCallback, useMemo } from 'react';
import { useDepartments } from '@/common/useDepartments';
import { useGetDrivers } from '../../query/calendarGrid.hooks';
import { useCalendarState } from './useCalendarState';

export const DriverSelect = () => {
  const { state, setSelectedDriverId, setTimeSlots } = useCalendarState();
  const { selectedDepartmentId: departmentId } = useDepartments();
  const handleDriverSelect = useCallback(
    (driverId: string) => {
      setSelectedDriverId(driverId);
      setTimeSlots([]);
    },
    [setSelectedDriverId, setTimeSlots]
  );

  const { data: driversData, isLoading } = useGetDrivers({ departmentId });

  const options = useMemo(() => {
    return driversData?.user.map((driver) => (
      <Select.Option key={driver.id} value={driver.id}>
        {driver.name}
      </Select.Option>
    ));
  }, [driversData]);

  const displayValue = useMemo(() => {
    if (!state.selectedDriverId) return undefined;
    if (isLoading) return undefined;
    const driverExists = driversData?.user.some((d) => d.id === state.selectedDriverId);
    return driverExists ? state.selectedDriverId : undefined;
  }, [state.selectedDriverId, isLoading, driversData]);

  return (
    <Select
      style={{ width: 300 }}
      placeholder="Select driver"
      onChange={handleDriverSelect}
      showSearch
      optionFilterProp="children"
      value={displayValue}
      loading={isLoading}
    >
      {options}
    </Select>
  );
};
